export default {
  allEventsLoaded: function () {
    return this.events.length >= this.totalEvents
  }
}
